import { USER_TYPE } from '../enums';

/**
 * 第8条（用户 m00163）：交付管理后台只服务交付侧身份。
 *
 * 平台超级管理员登录后看到的是平台管理后台那一套（改前靠角色码比较恒定放行、拿到全量按钮面），
 * 本端不再保留该身份的第二套界面：登录与启动自检两步都**明确拒绝**，
 * ⛔ 不是「能进但看不到东西」的菜单/按钮级权限拒绝。
 *
 * 同源口径：平台侧 SuperAdminRoleCode 同样按码比较，本端大小写不敏感，与之一致。
 */
const PLATFORM_SUPER_ADMIN_ROLE: string = USER_TYPE.SUPER_ADMIN;

/** 平台超管被拒的上屏文案（登录页失败行与守卫跳回登录页共用同一句，页面不另造第二句） */
export const SUPER_ADMIN_REFUSAL_TEXT = '该账号为平台超级管理员，请从平台管理后台登录，本系统不提供其界面。';

/** 身份判据：角色码大小写不敏感地等于平台超管码 */
export function isPlatformSuperAdmin(user: { roleCode?: string | null } | null | undefined): boolean {
  return (user?.roleCode ?? '').toUpperCase() === PLATFORM_SUPER_ADMIN_ROLE;
}

/**
 * 超管拒绝不是登录失败：必须与「用户名或密码错误」区分开，也**不计入** 5 次锁定计数。
 * 用独立错误类承载，登录页按 instanceof 分流到同一句上屏文案，不需要新的业务码。
 */
export class SuperAdminConsoleRefusal extends Error {
  constructor() {
    super(SUPER_ADMIN_REFUSAL_TEXT);
    this.name = 'SuperAdminConsoleRefusal';
  }
}
